import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 24;

@Component({
  selector: 'app-workflow-icon',
  standalone: true,
  templateUrl: './workflow-icon.component.html'
})
export class WorkflowIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
